module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-navy-3-63bac51deeb8efa43d17a48427ed8d3b.webp";